export const LogoMark = ({ className = "h-9 w-9", light = true }) => {
  const ink = light ? "#FBF8F3" : "#0A1F18";
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <rect x="7" y="27" width="6" height="15" fill={ink} />
      <rect x="16" y="20" width="6" height="22" fill={ink} />
      <rect x="25" y="13" width="6" height="29" fill={ink} />
      <rect x="34" y="6" width="6" height="36" fill="#C87D55" />
    </svg>
  );
};

export const LogoFull = ({ light = true }) => (
  <div className="flex items-center gap-3" data-testid="logo-full">
    <LogoMark light={light} />
    <div className="leading-none">
      <span
        className={`block font-display text-[15px] font-bold tracking-[0.12em] ${
          light ? "text-[#FBF8F3]" : "text-[#0A1F18]"
        }`}
      >
        COLUMBUS
      </span>
      <span className="block font-mono text-[9px] uppercase tracking-[0.3em] text-[#B36C45]">
        Management Consulting
      </span>
    </div>
  </div>
);
